import React, { useState, useEffect } from 'react'
import useModal from 'hook/useModal'

// css
import 'assets/style/elements/line.scss'

function Line({ className = '', size = 1, color = 'black' }) {
  return <span className={`horizontal-line size-${size} ${color} ${className}`}></span>
}

export default Line
